import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Blog.css';

const BlogCard = ({ post }) => {
  return (
    <div>
      <article className='blogCard'>
        <img src={require(`../../assets/${post.image}`)} alt={post.title} className='blogImage' />
        <div className='textStyleforBlogCard'>
          <h3>{post.title}</h3>
          <div className='text-small'>{post.excerpt}</div>
        </div>
        <Link to={`/blog/${post.slug}`} className='blogCardOverlayLink' aria-label={`Read more about ${post.title}`} />
      </article>
      
    </div>
  );
};

export default BlogCard;
